var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigClapper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 996,
    height: 606,
    viewBox: "0 0 996 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M926.661 606L57.5895 605.329C25.3361 605.329 -0.434627 585.081 0.00555603 560.156L9.14936 104L995 104.764L985.856 560.92C985.416 585.835 958.905 606.019 926.661 606Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.07 100.39L11.33 100.09L12.49 56.34L58.86 56.49L103.39 90.49C103.953 91.1363 104.265 91.9631 104.27 92.82L104.07 100.39Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M926.661 594L57.5895 593.339C25.3361 593.339 -0.434627 573.372 0.00555603 548.795L9.14936 99L995 99.7531L985.856 549.549C985.416 574.116 958.905 594.018 926.661 594Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M993.82 128.68L61.88 132.32L9.22 114.26L9.92 98.71L995.34 94.86L993.82 128.68Z",
    fill: "#2D2D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.44 131.19L355.27 97.25L485.87 96.84L446.73 130.78L315.44 131.19Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.39 132.16L108.22 98.22L238.82 97.81L199.68 131.75L68.39 132.16Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M564.25 130.12L604.09 96.18L734.69 95.78L695.54 129.72L564.25 130.12Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M805.57 129.25L845.4 95.31L976 94.9L936.86 128.84L805.57 129.25Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.14 111.92L63.16 133.91L993.66 126.25L987.74 128.69L58.8 136.39L10.02 115.46L10.14 111.92Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M84.42 89.12L59.24 90.54L5.27 74.67L4.78 58.59L992.07 35.42L988.91 39.18L84.42 89.12Z",
    fill: "#090906"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M992.07 35.42L61.51 88.03L7.52999 72.16L7.04999 56.08L991.01 0.450012L992.07 35.42Z",
    fill: "#2D2D2D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313.75 38.76L352.82 71.58L483.23 64.21L444.85 31.35L313.75 38.76Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.04 52.68L106.12 85.5L236.53 78.13L198.14 45.27L67.04 52.68Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M562.19 24.65L601.27 57.47L731.68 50.1L693.29 17.24L562.19 24.65Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M803.15 11.16L842.23 43.98L972.63 36.61L934.25 3.75L803.15 11.16Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6721 77.2035C46.9252 76.0974 50.3128 71.0651 49.2386 65.9634C48.1645 60.8617 43.0352 57.6225 37.7822 58.7285C32.5292 59.8346 29.1415 64.8669 30.2157 69.9687C31.2899 75.0704 36.4191 78.3095 41.6721 77.2035Z",
    fill: "#D5D5D5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7 61C40.4716 60.8294 41.2694 60.8128 42.0474 60.9514C42.8254 61.0899 43.5684 61.3808 44.2337 61.8073C44.899 62.2338 45.4735 62.7875 45.9242 63.4366C46.3749 64.0858 46.6929 64.8176 46.86 65.59C48.59 71.52 44.06 73.11 44.06 73.11C44.06 73.11 43.29 74.41 43.73 74.86C44.53 75.67 46.95 75.23 48.32 70.37C50.52 62.6 42.01 59.17 42.01 59.17C42.01 59.17 39.51 58.5 38.81 59.69C38.11 60.88 38.53 61.41 39.7 61Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.84 62.11C35.84 62.11 37.84 62.11 37.39 61.22C36.94 60.33 36.2 60.13 35.14 60.86C34.08 61.59 32.14 62.64 32.88 63.1C33.62 63.56 35.84 62.11 35.84 62.11Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6377 69.6284C40.6916 69.4065 41.3715 68.3986 41.1565 67.3772C40.9414 66.3558 39.9128 65.7076 38.8589 65.9295C37.8051 66.1514 37.1251 67.1593 37.3401 68.1807C37.5552 69.2022 38.5839 69.8503 39.6377 69.6284Z",
    fill: "#A9A9A9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 76.51C43.75 76.51 35.44 78.67 32.4 72.64C29.36 66.61 31.47 63.09 31.47 63.09C31.47 63.09 27.86 67.41 31.54 73.09C36 80.12 43.75 76.51 43.75 76.51Z",
    fill: "#A9A9A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigClapper);
export default __webpack_public_path__ + "static/media/big-clapper.3c05788a4e6bda36f0d1b9e15b9d998a.svg";
export { ForwardRef as ReactComponent };